var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", { staticClass: "pt-0 pb-2" }, [
                _c("h4", { staticClass: "text-h6 mt-2" }, [_vm._v("History")]),
                _c(
                  "span",
                  { staticClass: "ml-auto" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "white--text",
                        attrs: { color: "admin-primary " },
                        on: { click: _vm.createBackup },
                      },
                      [
                        _vm._v(" Create Backup "),
                        _c("v-icon", { staticClass: "ml-1" }, [
                          _vm._v("mdi-backup-restore"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("v-card-text", [
                _c("table", { staticClass: "foex-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("No")]),
                      _c("th", [_vm._v("Backup File")]),
                      _c("th", [_vm._v("Created At")]),
                      _c("th", [_vm._v("Actions")]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.backupSrv.backups, function (backup, index) {
                      return _c("tr", { key: backup.id ?? index }, [
                        _c("td", [_vm._v(_vm._s(index + 1))]),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.downloadBackup(backup)
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1 cursor-pointer",
                                  attrs: { small: "" },
                                },
                                [_vm._v("mdi-file")]
                              ),
                              _vm._v(" " + _vm._s(backup.name) + " "),
                            ],
                            1
                          ),
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.$helpers.formatDate(
                                backup.created,
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          [
                            _c(
                              "base-btn",
                              {
                                staticClass: "mr-1",
                                attrs: { small: "", outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadBackup(backup)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1 cursor-pointer",
                                    attrs: { small: "" },
                                  },
                                  [_vm._v("mdi-download")]
                                ),
                                _vm._v(" Download "),
                              ],
                              1
                            ),
                            _c(
                              "base-btn",
                              {
                                staticClass: "shadown-none",
                                attrs: {
                                  color: "red",
                                  small: "",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteBackup(backup)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { size: "medium" },
                                  },
                                  [_vm._v(" mdi-delete ")]
                                ),
                                _vm._v(" Delete "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c("BackupFilePreviewDialogComponent", {
            ref: "backupFilePreviewDialogRef",
            attrs: {
              name: "backup-file-preview-dialog",
              "file-content": _vm.previewContent,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }